var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"9","viewBox":"0 0 14 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.6466 0.5L13.7644 1.61781L6.88219 8.5L0 1.61781L1.11781 0.5L6.88219 6.26438L12.6466 0.5Z","fill":"#10233E"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }